import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import {BooleanConverter, BooleanFormatterWithCSS, titleCaseByUnderscore} from '../../components'
import { OrganizationSelector } from '../Organizations/OrganizationSelector'

export const UserRightsTable = ({ rights }) => {
  const columns = [
    {
      dataField: 'organization_code',
      text: 'Code',
    },
    {
      dataField: 'is_active',
      text: 'Status',
      formatter: BooleanFormatterWithCSS('is_active', 'text-success text-center')



    },
    {
      dataField: 'organization_name',
      formatter: (cell, row) => {
        return (
          <div className="text-end">
            <OrganizationSelector
                variant="Button"
                organizationRight={row}             ></OrganizationSelector>
          </div>
        )
      },
    },
  ]
  const expandRow = {
    renderer: (row) => (
      <ReactBootstrap.Table size="sm">
        <tbody>
          <tr>
            <th>Tickets</th>
            <td>{BooleanConverter(row.tickets)}</td>
          </tr>
          <tr>
            <th>Repair Inventory</th>
            <td>{BooleanConverter(row.repair_inventory)}</td>
          </tr>
          <tr>
            <th>Loaner Inventory</th>
            <td>{BooleanConverter(row.loaner_inventory)}</td>
          </tr>
          <tr>
            <th>Non Serialized Inventory</th>
            <td>{BooleanConverter(row.non_serialized_inventory)}</td>
          </tr>
          <tr>
            <th>DSR Download</th>
            <td>{BooleanConverter(row.status_report_download)}</td>
          </tr>
          <tr>
            <th>Customer Report Download</th>
            <td>{BooleanConverter(row.customer_report_download)}</td>
          </tr>
         <tr>
            <th>Delivery Report Download</th>
            <td>{BooleanConverter(row.delivery_report_download)}</td>
          </tr>
           <tr>
            <th>{titleCaseByUnderscore("loaner_record_report_download")}</th>
            <td>{BooleanConverter(row.loaner_record_report_download)}</td>
          </tr>
         <tr>
            <th>{titleCaseByUnderscore("non_serialized_order_line_report_download")}</th>
            <td>{BooleanConverter(row.non_serialized_order_line_report_download)}</td>
          </tr>
         <tr>
            <th>{titleCaseByUnderscore("order_line_report_download")}</th>
            <td>{BooleanConverter(row.order_line_report_download)}</td>
          </tr>
         <tr>
             <th>{titleCaseByUnderscore("non_serialized_order_line_report_download")}</th>
            <td>{BooleanConverter(row.non_serialized_order_line_report_download)}</td>
          </tr>
         <tr>
           <th>{titleCaseByUnderscore("voucher_report_download")}</th>
            <td>{BooleanConverter(row.voucher_report_download)}</td>
          </tr>

        </tbody>
      </ReactBootstrap.Table>
    ),
  }

  return rights ? (
      <div style={{marginTop:"15px"}}>
    <BootstrapTable
      keyField="organization_code"
      data={rights}
                striped
  hover
  condensed
        bordered={false}
      expandRow={expandRow}
      columns={columns}
      pagination={paginationFactory({ hideSizePerPage: true })}
    /></div>
  ) : (
    <div>No Results Found.</div>
  )
}
